<template>
    <div id="container">
        <Header></Header>
        <router-view />
        <Footer></Footer>
        <GoTop></GoTop>
    </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import GoTop from '@/components/GoTop.vue'
export default {
    name: 'PageView',
    components:{
        Header,
        Footer,
        GoTop
    },
}
</script>
<style scoped>

</style>

